import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastService } from 'src/app/core/toast.service';
import { ApiComandamesaService } from 'src/app/dao/api-comandamesa.service';
import { GlobalService } from 'src/app/dao/global.service';
import { Comandamesa } from 'src/app/model/comandamesa';

@Component({
  selector: 'app-comandamesa',
  templateUrl: './comandamesa.page.html',
  styleUrls: ['./comandamesa.page.scss'],
  providers: [MessageService, ConfirmationService],
})
export class ComandamesaPage implements OnInit {
  comandamesaDialog: boolean;

  comandamesas: Comandamesa[];

  comandamesa: Comandamesa;

  selectedcomandamesas: Comandamesa[];

  submitted: boolean;

  grupos = [];
  
  tituloComandaMesa;

  quantidade = 0;

  quantidadeTotal = 0;

  carregando = false;

  campoSenha;

  senhaAdm;

  novoValor;

  readonlyCampos = false;

  // tslint:disable-next-line: max-line-length
  constructor(private alertController: AlertController, private global: GlobalService, private comandamesaservice: ApiComandamesaService, private toast: ToastService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.tituloComandaMesa = this.global.comandaMesa;
    this.senhaAdm = this.global.senha_adm;
    this.comandamesa = new Comandamesa();
    this.comandamesaservice.listarTodas().then(data => this.comandamesas = data);
    this.getStatus();

  }



  openNew() {
    this.readonlyCampos = false;
    // tslint:disable-next-line: new-parens
    this.comandamesa = {};
    this.submitted = false;
    this.comandamesaDialog = true;
  }

  delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }


    alterarValores() {
    if(this.novoValor >= 0){
  
      let texto;

      if(this.novoValor != null){
        console.log("Entrou no if valor normal");
        texto = "Deseja mesmo alterar o valor das "+this.tituloComandaMesa+" selecionadas para R$"+this.novoValor.toFixed(2).replace('.', ',')+" ?";
      }

      this.confirmationService.confirm({
      message: texto,
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        //this.prods = this.prods.filter(val => !this.selectedfretes.includes(val));
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.selectedcomandamesas.length; i++) {
            
          this.selectedcomandamesas[i].maximo = this.novoValor;
          
          if(this.selectedcomandamesas[i].maximo >= 0){
            console.log(this.selectedcomandamesas[i]);
            const result = this.comandamesaservice.atualizar(this.selectedcomandamesas[i]);
            console.log(result);
          }else{
            this.toast.showSucess('O valor deve ser maior que zero!');
          }
          
        }
        this.selectedcomandamesas = undefined;
        this.toast.showSucess('Valores atualizados com sucesso!');
        //this.produtoService.GetByCat(this.idCat).then(data => this.prods = data);
      }
    });

  }else{
    this.toast.showError("Preencha um campo de valor!")
      return console.log("else");
      
  }
  }

  confirmDeleteSelectedcomandamesas() {
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar as '+ this.tituloComandaMesa +'s selecionadas? ATENÇÃO: APENAS '+ this.tituloComandaMesa +'s LIBERADAS SERÃO EXCLUIDAS!',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.comandamesas = this.comandamesas.filter(val => !this.selectedcomandamesas.includes(val));
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.selectedcomandamesas.length; i++) {
          const result = this.comandamesaservice.excluir(this.selectedcomandamesas[i].id);
        }
        this.selectedcomandamesas = null;
        this.comandamesaservice.listarTodas().then(data => this.comandamesas = data);
        this.toast.showSucess(this.tituloComandaMesa + 's Excluídas com Sucesso!');
      }
    });
  }

  async deleteSelectedcomandamesas() {
    if(this.senhaAdm === null || this.senhaAdm === "" || this.senhaAdm === undefined){
      const alert = await this.alertController.create({
        header: 'Aviso',
        subHeader: 'Importante',
        message: 'Esta funcionalidade necessita da geração de uma senha de administrador. <br> Para mais informações, entre em contato conosco. <a href="https://api.whatsapp.com/send?phone=5511963697271">clicando aqui</a> pelo WhatsApp (11) 96369-7271',
        buttons: ['OK']
      });
  
      await alert.present();
      return null;
    }
  const alert = await this.alertController.create({
    header: 'Por favor, insira a senha de administrador para realizar esta operação',
    inputs: [
      {
        name: 'input1',
        placeholder: 'Senha',
        type: 'password',
      },
    ],
    buttons: [
      {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
              console.log('Confirm Cancel');
          }
      }, 
      {
          text: 'Enviar',
          handler: (alertData) => {
              console.log(alertData.input1);
              if(this.senhaAdm === alertData.input1){
                this.confirmDeleteSelectedcomandamesas();
              }else{
                this.toast.showError('Senha incorreta!');
              }
          }
      }
  ],
  });

  await alert.present();
  }

  editcomandamesa(comandamesa: Comandamesa, completo) {
    if(completo){
      this.readonlyCampos = false;
    }else{
      this.readonlyCampos = true;
    }
    this.comandamesa = {...comandamesa};
    this.comandamesaDialog = true;
  }

  deletecomandamesa(comandamesa: Comandamesa) {
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar a ' + this.tituloComandaMesa  + ' ' + comandamesa.codigo + '? ATENÇÃO: APENAS '+ this.tituloComandaMesa +'s LIBERADAS SERÃO EXCLUIDAS!',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const result = this.comandamesaservice.excluir(comandamesa.id);
        this.comandamesas = this.comandamesas.filter(val => val.id !== comandamesa.id);
        this.comandamesa = {};
        this.toast.showSucess(this.tituloComandaMesa + ' Excluída com Sucesso!');
        this.comandamesaservice.listarTodas().then(data => this.comandamesas = data);
      }
    });
  }

  hideDialog() {
    this.comandamesaDialog = false;
    this.submitted = false;
  }

  async reiniciarComandaMesas(){
    if(this.senhaAdm === null || this.senhaAdm === "" || this.senhaAdm === undefined){
      const alert = await this.alertController.create({
        header: 'Aviso',
        subHeader: 'Importante',
        message: 'Esta funcionalidade necessita da geração de uma senha de administrador. <br> Para mais informações, entre em contato conosco. <a href="https://api.whatsapp.com/send?phone=5511963697271">clicando aqui</a> pelo WhatsApp (11) 96369-7271',
        buttons: ['OK']
      });
  
      await alert.present();
      return null;
    }
  const alert = await this.alertController.create({
    header: 'Por favor, insira a senha de administrador para realizar esta operação',
    inputs: [
      {
        name: 'input1',
        placeholder: 'Senha',
        type: 'password',
      },
    ],
    buttons: [
      {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
              console.log('Confirm Cancel');
          }
      }, 
      {
          text: 'Enviar',
          handler: (alertData) => {
              console.log(alertData.input1);
              if(this.senhaAdm === alertData.input1){
                this.reiniciarComandaMesas2();
              }else{
                this.toast.showError('Senha incorreta!');
              }
          }
      }
  ],
  });

  await alert.present();
}

  async reiniciarComandaMesas2() {
    let idComandas;
    this.quantidade = 0;
    this.quantidadeTotal = this.selectedcomandamesas.length;
    let qtdMesas = this.selectedcomandamesas.length;
    this.confirmationService.confirm({
      message: 'Deseja mesmo reiniciar a(s) ' + this.tituloComandaMesa + '(s) selecionada(s)? ATENÇÃO: todos os pedidos serão cancelados!',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: async() => {
        this.carregando = true;
        console.log(this.selectedcomandamesas);
        for (let i = 0; i < this.selectedcomandamesas.length; i++) {
          try
          {
            const result = await this.comandamesaservice.reset(this.selectedcomandamesas[i].id);
            this.quantidade = this.quantidade + 1;
          }
          catch{
            this.toast.showError('Ocorreu um erro ao reiniciar as ' + this.tituloComandaMesa + ' ' + qtdMesas + ' Foram reiniciadas!');
            this.selectedcomandamesas = [];
            this.comandamesaservice.listarTodas().then(data => this.comandamesas = data);
            this.carregando = false;
          }
          
        }
        this.toast.showSucess(qtdMesas + ' ' + this.tituloComandaMesa + ' Reiniciadas com Sucesso!');
        this.selectedcomandamesas = [];
        this.comandamesaservice.listarTodas().then(data => this.comandamesas = data);
        this.carregando = false;
      }
      
    });
  }


 async savecomandamesa() {
    this.submitted = true;
    if (this.comandamesa.codigo.trim()) {
      if (this.comandamesa.id) {
        this.comandamesas[this.findIndexById(this.comandamesa.id)] = this.comandamesa;
        this.comandamesa.codigo = this.comandamesa.codigo.replace(/\s/gi, '_');
        const result = this.comandamesaservice.atualizar(this.comandamesa);
        this.toast.showSucess(this.tituloComandaMesa + ' Atualizada com Sucesso!');
      } else {
        // tslint:disable-next-line: radix
        this.comandamesa.codigo = this.comandamesa.codigo.replace(/\s/gi, '_');
        const result = await this.comandamesaservice.adicionar(this.comandamesa);
        this.comandamesas.push(result);
        this.toast.showSucess(this.tituloComandaMesa + ' Cadastrada com Sucesso!');
      }

      this.comandamesas = [...this.comandamesas];
      this.comandamesaDialog = false;
      this.comandamesa = {};
    }
  }


  getStatus() {
  let statusAux = [
  {name: 'Liberada', code: 'LIBERADA'},
  {name: 'Inativa', code: 'INATIVA'}
];

    this.grupos = statusAux.map(c => {
      return ({ label: c.name, value: c.code });
      // tslint:disable-next-line: align
    });
}

  findIndexById(id: number): number {
    let index = -1;
    for (let i = 0; i < this.comandamesas.length; i++) {
      if (this.comandamesas[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  }



}



